export default "__VITE_ASSET__Dwa3AvwM__"